import { useMutation } from "react-query";
import ObjectTagValuesDataService from "../../services/object-tag-values-data-service/ObjectTagValuesDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { useSaveObjectTagValuesConfiguration } from "./UseSaveObjectTagValuesConfiguration";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export type UseRenameObjectTagValuesConfigurationResultType = {
    oldName: string;
    newName: string;
};

export type UseRenameObjectTagValuesConfigurationParameters = {
    groupID: number,
    objectType: eLynxObjectTypeEnum,
    objectID: number,
    configurationID: number
} & BaseUseMutationParameters<UseRenameObjectTagValuesConfigurationResultType, string>;

export function useRenameObjectTagValuesConfiguration({
    groupID,
    objectType,
    objectID,
    configurationID,
    onError,
    onSuccess
}: UseRenameObjectTagValuesConfigurationParameters) {

    const { mutateAsync: saveConfiguration } = useSaveObjectTagValuesConfiguration({
        groupID,
        objectType,
        objectID
    });

    return useMutation<UseRenameObjectTagValuesConfigurationResultType, RestError, string>(
        async (name) => {

            const model = await ObjectTagValuesDataService.getConfiguration(
                groupID,
                configurationID
            );
            const oldName = model.name;
            model.name = name;

            await saveConfiguration(model);

            return {
                oldName: oldName,
                newName: name
            };
        },
        {
            onError: onError,
            onSuccess: onSuccess
        }
    );
}